"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonContract = void 0;
const ton_core_1 = require("ton-core");
const Ton_1 = require("./Ton");
class TonContract extends Ton_1.Ton {
    static getName() {
        throw "Must be overridden; Return the contract-filename here;";
    }
    constructor(address, init) {
        super();
        this.address = address;
        this.init = init;
    }
    async sendDeploy(provider) {
        console.log("contract address:", this.address.toString());
        return await this.internalMessage(provider, 0.05, (0, ton_core_1.beginCell)().endCell());
    }
}
exports.TonContract = TonContract;
//# sourceMappingURL=TonContract.js.map